"use client";
import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { AiOutlineUser } from "react-icons/ai";

interface CustomerProps {
  item: any;
  index: number;
}
const CustomerItems: React.FC<CustomerProps> = ({ item, index }) => {
  const navigate = useNavigate();
  // const location = useLocation();
  // const { id } = location.state || {}; // Truy cập vào 'id' từ 'state', mặc định là trả về undefined nếu không có state
  return (
    <div
      onClick={() => {
        navigate("/admin/editUser", { state: { item } });
      }}
      className="w-full my-2 cursor-pointer rounded-2xl border border-[pink] bg-white/70 hover:bg-[pink] hover:text-white transition-colors shadow-sm"
    >
      <div className="flex items-start gap-3 p-4">
        {item?.avatar ? (
          <img
            className="w-[44px] h-[44px] rounded-full object-cover border border-[pink] bg-white"
            src={item?.avatar?.replace(
              "http://27.71.26.120",
              "https://phototimevn.com"
            )}
          />
        ) : (
          <div className="w-[44px] h-[44px] rounded-full border border-[pink] grid place-items-center bg-white">
            <AiOutlineUser size={22} />
          </div>
        )}

        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <div className="font-medium truncate max-w-[200px] sm:max-w-[260px]">
              {item?.name || "Chưa có tên"}
            </div>
            {item?.role && (
              <span className="px-2 py-0.5 text-xs rounded-full border border-[pink] bg-white/60 text-[pink] group-hover:text-white group-hover:border-white">
                {item.role}
              </span>
            )}
            {item?.isBlock ? (
              <span className="px-2 py-0.5 text-xs rounded-full bg-red-100 text-red-600 border border-red-200">Đã chặn</span>
            ) : (
              <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-700 border border-green-200">Hoạt động</span>
            )}
          </div>

          <div className="mt-1 text-sm opacity-80 flex flex-wrap gap-x-4 gap-y-1">
            <span className="truncate">SĐT: {item?.phoneNumber || "-"}</span>
            <span className="truncate">Chi nhánh: {item?.branh_resgisted || "-"}</span>
            {item?.birdthDay && <span>SN: {item.birdthDay}</span>}
          </div>

          <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs">
            <div className="rounded-lg border border-[pink]/40 bg-white/60 px-2 py-1">
              <div className="opacity-70">Tích điểm</div>
              <div className="font-semibold">{item?.accumulate_points?.count ?? 0}</div>
            </div>
            <div className="rounded-lg border border-[pink]/40 bg-white/60 px-2 py-1">
              <div className="opacity-70">Điểm danh</div>
              <div className="font-semibold">{item?.dailyCheckin?.count ?? 0}</div>
            </div>
            <div className="rounded-lg border border-[pink]/40 bg-white/60 px-2 py-1">
              <div className="opacity-70">Tạo lúc</div>
              <div className="font-semibold truncate" title={item?.create_date || item?.createdAt}>{item?.create_date || item?.createdAt || "-"}</div>
            </div>
            <div className="rounded-lg border border-[pink]/40 bg-white/60 px-2 py-1">
              <div className="opacity-70">Thông báo</div>
              <div className="font-semibold truncate" title={item?.notiStatus}>{item?.notiStatus || "-"}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerItems;
